import type { ReactElement } from 'react';
import { Tooltip as Base } from '@base-ui/react/tooltip';
import { CANVAS_UI } from '../features/editor/canvas-ui';
import { Kbd } from './Kbd';

/** Hover/focus label of a control, with its shortcut; the control keeps its own accessible name. */
export function Tooltip({ label, shortcut, side = 'top', children }: { label: string; shortcut?: string; side?: 'top' | 'bottom' | 'left' | 'right'; children: ReactElement }) {
  return (
    <Base.Root>
      <Base.Trigger delay={400} render={children} />
      <Base.Portal>
        <Base.Positioner side={side} sideOffset={8} className="z-[60]" {...{ [CANVAS_UI]: '' }}>
          <Base.Popup className="os-pop flex items-center gap-2 rounded-full bg-fg px-2.5 py-1 font-sans text-xs font-medium text-bg shadow-md">
            <span>{label}</span>
            {shortcut && <Kbd className="border-transparent bg-fg-muted/30 text-bg">{shortcut}</Kbd>}
          </Base.Popup>
        </Base.Positioner>
      </Base.Portal>
    </Base.Root>
  );
}

export const TooltipProvider = Base.Provider;
